"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Tooltip = require("./Tooltip.types");
var _Typography = _interopRequireDefault(require("../../Typography"));
var _Typography2 = require("../../Typography/Typography.types");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) {
    if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {
        ;
      }
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
} /* eslint-disable @typescript-eslint/ban-ts-comment */
var styles = {
  "tooltip": "gn1LoB",
  "label": "_4Qwk8O",
  "triggerWrapper": "qWDeCu",
  "visible": "mRZ8KE",
  "bottom": "EA1D9w",
  "bottomLeft": "R4Af1v",
  "bottomRight": "-T4Nh7",
  "top": "DaJAVC",
  "topLeft": "OPaQRI",
  "topRight": "_5pQ4I5"
};
var Tooltip = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var label = _ref.label,
    showTooltip = _ref.showTooltip,
    tooltipWidth = _ref.tooltipWidth,
    disabled = _ref.disabled,
    children = _ref.children,
    className = _ref.className,
    position = _ref.position;
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    triggerRefWidth = _useState2[0],
    setTriggerWidth = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    triggerRefHeight = _useState4[0],
    setTriggerHeight = _useState4[1];
  var triggerRef = (0, _react.useRef)(null);
  var triggerComponent = _react.Children.only(children);
  (0, _react.useEffect)(function () {
    if (triggerRef.current) {
      setTriggerWidth(triggerRef.current.clientWidth);
      setTriggerHeight(triggerRef.current.clientHeight);
    }
  }, [triggerRef, triggerRefWidth, triggerRefHeight]);
  var tooltipClassnames = (0, _clsx["default"])('Cozy-Tooltip', styles.tooltip, styles[position]);
  var tooltipStyleVariables = {
    '--height': "".concat(triggerRefHeight, "px"),
    '--width': "".concat(tooltipWidth || 240, "px"),
    '--line-height': triggerRefHeight ? "".concat(triggerRefHeight, "px") : '100%'
  };
  var wrapperClassnames = (0, _clsx["default"])('Cozy-TooltipTriggerWrapper', className, styles.triggerWrapper, !disabled && showTooltip ? styles.visible : '');
  var wrapperStyleVariables = {
    '--height': triggerRefWidth ? "".concat(triggerRefWidth, "px") : 'auto',
    '--width': triggerRefHeight ? "".concat(triggerRefHeight, "px") : 'auto'
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: wrapperClassnames,
    style: wrapperStyleVariables
  }, /*#__PURE__*/(0, _react.isValidElement)(triggerComponent) && /*#__PURE__*/(0, _react.cloneElement)(triggerComponent, {
    ref: triggerRef
  }), showTooltip && /*#__PURE__*/_react["default"].createElement("div", {
    role: "presentation",
    ref: ref,
    className: tooltipClassnames,
    style: tooltipStyleVariables
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: styles.label
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    level: _Typography2.Level.CAPTION,
    kind: _Typography2.Kind.DEFAULT
  }, label))));
});
Tooltip.propTypes = process.env.NODE_ENV !== "production" ? {
  label: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].string]).isRequired,
  showTooltip: _propTypes["default"].bool,
  tooltipWidth: _propTypes["default"].number,
  disabled: _propTypes["default"].bool,
  children: _propTypes["default"].node,
  className: _propTypes["default"].string,
  position: _propTypes["default"].oneOf(Object.values(_Tooltip.Position))
} : {};
Tooltip.defaultProps = {
  position: _Tooltip.Position.BOTTOM
};
var _default = exports["default"] = Tooltip;